import React, { useState, useCallback } from "react";
import ReactDOM from "react-dom";
import "./MapImage.scss";
import aosboxImage from "../../assets/aosbox.png";

const ImageLightbox = ({ imageURL, onClose }) => {
  const handleKeyDown = useCallback((e) => {
    if (e.key === "Escape") onClose();
  }, [onClose]);

  return ReactDOM.createPortal(
    <div
      className="image-lightbox-overlay"
      onClick={onClose}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      ref={(el) => el?.focus()}
    >
      <div className="image-lightbox-content" onClick={(e) => e.stopPropagation()}>
        <button className="image-lightbox-close" onClick={onClose}>
          &times;
        </button>
        <img
          className="image-lightbox-image"
          src={imageURL}
          alt="Map enlarged"
        />
      </div>
    </div>,
    document.body
  );
};

const MapImage = ({ imageURL }) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasImage = !!imageURL;

  const handleClick = (e) => {
    e.stopPropagation();
    if (hasImage) setIsOpen(true);
  };

  return (
    <>
      <div
        className="map-image-container"
        onClick={handleClick}
        style={{ cursor: hasImage ? "pointer" : "default" }}
      >
        {hasImage ? (
          <img className="map-image" src={imageURL} alt="Map" />
        ) : (
          <img className="map-image-placeholder" src={aosboxImage} alt="AOS Box" />
        )}
      </div>

      {isOpen && (
        <ImageLightbox
          imageURL={imageURL}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default MapImage;
